import Form from "react-bootstrap/Form";
import { ONE_MB_IN_BYTES, ALLOWED_MODEL_FILE_EXTENSIONS } from "../../../Constants";
import { forwardRef } from "react";

// FileUploadForm is used for Android and desktop browsers
const FileUploadForm = forwardRef(({ onChange }, ref) => {
  const acceptExtensions = ALLOWED_MODEL_FILE_EXTENSIONS.map(extension => `.${extension}`).join(', ');
  return (
  <Form.Group controlId="formFile">
    <Form.Control
      type="file"
      accept={acceptExtensions}
      className="custom-file-input"
      onChange={onChange}
      ref={ref}
    />
  </Form.Group>)
});

// IOSFileUploadForm is used for iOS browsers
const IOSFileUploadForm = forwardRef(({ onChange }, ref) => (
  <Form.Group controlId="formFile">
    <Form.Control
      type="file"
      // capture="filesystem"
      className="custom-file-input"
      onChange={onChange}
      ref={ref}
    />
  </Form.Group>
));

// FileUpload is a wrapper component that renders the appropriate form based on the browser
const FileUpload = forwardRef(({ handleFileChange }, ref) => {
  const isAppleDevice = /(Mac|iPhone|iPod|iPad)/.test(navigator.userAgent);

  return (
    <div>
      {isAppleDevice ? (
        <IOSFileUploadForm onChange={handleFileChange} ref={ref}/>
      ) : (
        <FileUploadForm onChange={handleFileChange} ref={ref}/>
      )}
    </div>
  );
});

/**
 * Slices a file into smaller chunks and uploads it.
 * @param {File} file - The file to be uploaded.
 * @param {function(number) : void} onChunkUploaded - Called after each chunk gets uploaded. Can be used for progress tracking.
 * @param {function() : void} onFileUploaded - Called after all the chunks were sucessfuly uploaded.
 * @returns {void}
 */
export const uploadFileInChunks = (file, onChunkUploaded, onFileUploaded) => {
  let progress = 0;

  const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
  const modelJobGuid = crypto.randomUUID();
  const temporaryFileGuid = crypto.randomUUID();
  
  const chunkSize = ONE_MB_IN_BYTES;
  const chunks = Math.ceil(file.size / chunkSize);
  let currentChunk = 0;
  const uploadFileChunk = (start, end) => {
      const blob = file.slice(start, end);

      const formData = new FormData();
      formData.append("chunkMetadata", JSON.stringify({ FileGuid: temporaryFileGuid, Index: currentChunk, TotalCount: chunks }));
      formData.append('file', blob, file.name);
      fetch(`/Registration/model/${modelJobGuid}/${fileExtension}`, {
          method: 'POST',
          body: formData,
      })
      .then((response) => {
          if (response.ok) {
              currentChunk++;

              if (currentChunk < chunks) {
                  progress = Math.round((currentChunk / chunks) * 100);
                  if (onChunkUploaded)
                    onChunkUploaded(progress);
                  // Continue with the next chunk
                  const nextStart = end;
                  const nextEnd = Math.min(end + chunkSize, file.size);
                  uploadFileChunk(nextStart, nextEnd);
              } else {
                  if (onFileUploaded)
                    onFileUploaded();
              }
          } else {
              console.error('Failed to upload file:', response.statusText);
          }
      })
      .catch((error) => {
          console.error('Error uploading file:', error);
      });
  };
  const initialChunkSize = Math.min(chunkSize, file.size);
  uploadFileChunk(0, initialChunkSize);
};

export default FileUpload;